module.exports = __webpack_public_path__ + "img/工单系统_xz.7d3050bd.jpg";